import { SvgProps } from "components/icons/types";

export const IncorporationIcon = (props: SvgProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_7092_21440)">
        <path
          d="M12.9725 5.98198L12.936 5.56398L12.518 5.52748C11.0545 5.39898 9.96 5.72248 9.2675 6.48748C8.44 7.40248 8.4675 8.65698 8.526 9.19598L7.5 10.222V6.92548C7.898 6.61848 8.9365 5.69398 9.0035 4.35298C9.0565 3.28898 8.493 2.25348 7.3285 1.27598L7.007 1.00598L6.6855 1.27598C5.521 2.25348 4.957 3.28898 5.0105 4.35298C5.0765 5.67748 6.0915 6.59648 6.5 6.91498V10.222L5.474 9.19598C5.5325 8.65748 5.56 7.40248 4.7325 6.48748C4.04 5.72248 2.945 5.39848 1.482 5.52748L1.064 5.56398L1.0275 5.98198C0.8995 7.44648 1.2225 8.54048 1.9875 9.23248C2.691 9.86848 3.597 9.99948 4.223 9.99948C4.4885 9.99948 4.694 9.97648 4.8225 9.95798L6.5 11.6355V13.0055H7.5V11.6355L9.1775 9.95798C9.3055 9.97648 9.511 9.99948 9.777 9.99948C10.403 9.99948 11.3095 9.86848 12.0125 9.23248C12.7775 8.53998 13.1005 7.44648 12.9725 5.98198ZM4.4895 8.98848C4.065 9.02198 3.2265 9.00498 2.6585 8.49098C2.2065 8.08198 1.9855 7.41348 2.0005 6.50048C2.919 6.47948 3.5825 6.70648 3.991 7.15848C4.507 7.72848 4.522 8.56398 4.4895 8.98848ZM6.0095 4.30248C5.9775 3.65998 6.313 2.99748 7.0075 2.32948C7.702 2.99748 8.0375 3.65998 8.0055 4.30248C7.9645 5.11698 7.343 5.75198 7.0075 6.03698C6.6715 5.75148 6.05 5.11698 6.0095 4.30248ZM11.342 8.49048C10.7715 9.00648 9.936 9.02148 9.512 8.98898C9.4805 8.56348 9.496 7.72598 10.0095 7.15798C10.4185 6.70598 11.081 6.48498 12 6.49998C12.015 7.41298 11.794 8.08148 11.342 8.49048Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_7092_21440">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
